const portalPaths = {
    financial: {
        title: 'Operator Financial Report',
        path: '/internal-portal/operator-financial-report',
        viewReport: 'View Operator Report',
    },
    monitoring: {
        // title: 'Operator HR Monitoring',
        title: 'License & Employee',
        path: '/internal-portal/operator-hr-monitoring',
        viewOperator: 'View Operator HR',
        viewOperatorDocument: 'View License Documents',
        operatorHrInfo: 'Operator HR info',
        editEmployee: 'Edit Employee info',
        createEmployee: 'Create new operator employee',
        viewDocument: 'View License Documents',
        licenseManagement: 'License Management',
        employeeManagement: 'Employee Management',
        deviceManagement: 'Device Management',
        viewEmployee: 'View Employee Info',
    },
    lcm: {
        title: 'LCM Internal HR',
        path: '/internal-portal/lcm-internal-hr',
        createEmployee: 'Create new employee',
        editEmployee: 'Edit employee info',
        viewEmployee: 'View employee info',
    },
    management: {
        title: 'User Management',
        path: '/internal-portal/user-management',
        userType: 'User type',
        userInfo: 'User type info',
        userSecurity: 'System Security',
        editUserType: 'Edit user type',
        createUserType: 'Create new user type',
        changePassword: 'Change password',
    },
    activity: {
        title: 'User Activity',
        path: '/internal-portal/user-activity',
    },
    applicationTracking: {
        title: 'Application Tracking',
        path: '/internal-portal/application-tracking',
    },
    profileSettings: {
        title: 'Profile Setting',
        path: '/internal-portal/profile',
    },
    employeeManagement: {
        title: 'Employee Management',
        path: '/internal-portal/operator-hr-monitoring/employee-management',
    },
}
// state
export const state = () => ({
    menubarInternalPortal: [
        {
            icon: 'mdi-poll',
            title: portalPaths.financial.title,
            to: portalPaths.financial.path,
            display: true,
            code: 'operator_financial_report',
        },
        {
            icon: 'mdi-monitor',
            title: portalPaths.monitoring.title,
            to: `${portalPaths.monitoring.path}/license-management`,
            display: false,
            code: 'operator_hr_monitoring',
            children: [
                {
                    title: 'License management',
                    to: `${portalPaths.monitoring.path}/license-management`,
                    display: true,
                    code: 'operator_hr_monitoring',
                },
                {
                    title: portalPaths.monitoring.employeeManagement,
                    to: `${portalPaths.monitoring.path}/employee-management`,
                    display: true,
                    code: 'operator_hr_monitoring',
                },
            ],
        },
        {
            icon: 'mdi-account-outline',
            title: portalPaths.lcm.title,
            to: portalPaths.lcm.path,
            display: false,
            code: 'lcm_internal_hr',
        },
        {
            icon: 'mdi-cellphone',
            title: portalPaths.applicationTracking.title,
            to: portalPaths.applicationTracking.path,
            display: true,
            code: 'application_tracking',
        },
        {
            icon: 'mdi-account-multiple',
            title: portalPaths.management.title,
            to: portalPaths.management.path,
            display: true,
            code: 'user_management',
        },
        {
            icon: 'mdi-chart-line-variant',
            title: 'User activity',
            to: '/internal-portal/user-activity',
            display: true,
            code: 'user_activity',
        },
    ],
    // This below array is for Page Title and Breadcrumbs
    titleAndPathInternalPortal: [
        {
            path: portalPaths.financial.path,
            title: portalPaths.financial.title,
            lists: [
                {
                    text: portalPaths.financial.title,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.financial.path}/view-report/*`,
            title: portalPaths.financial.viewReport,
            lists: [
                {
                    text: portalPaths.financial.title,
                    href: portalPaths.financial.path,
                    disabled: false,
                },
                {
                    text: portalPaths.financial.viewReport,
                    disabled: true,
                },
            ],
        },
        {
            path: portalPaths.monitoring.path,
            title: portalPaths.monitoring.title,
            lists: [
                {
                    text: portalPaths.monitoring.title,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.monitoring.path}/license-management/devices/*`,
            title: portalPaths.monitoring.deviceManagement,
            lists: [
                {
                    text: portalPaths.monitoring.licenseManagement,
                    href: `${portalPaths.monitoring.path}/license-management`,
                    disabled: false,
                },
                {
                    text: portalPaths.monitoring.deviceManagement,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.monitoring.path}/license-management`,
            title: portalPaths.monitoring.licenseManagement,
            lists: [
                {
                    text: portalPaths.monitoring.licenseManagement,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.monitoring.path}/employee-management/*`,
            title: portalPaths.monitoring.viewEmployee,
            lists: [
                {
                    text: portalPaths.monitoring.licenseManagement,
                    href: `${portalPaths.monitoring.path}/employee-management`,
                    disabled: false,
                },
                {
                    text: portalPaths.monitoring.viewEmployee,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.monitoring.path}/employee-management`,
            title: portalPaths.monitoring.employeeManagement,
            lists: [
                {
                    text: portalPaths.monitoring.licenseManagement,
                    disabled: true,
                },
                {
                    text: portalPaths.monitoring.employeeManagement,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.monitoring.path}/license-management/edit/*`,
            title: 'Edit license management',
            lists: [
                {
                    text: portalPaths.monitoring.licenseManagement,
                    href: `${portalPaths.monitoring.path}/license-management`,
                    disabled: false,
                },
                {
                    text: 'Edit license management',
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.monitoring.path}/license-management/employee/*`,
            title: portalPaths.monitoring.viewEmployee,
            lists: [
                {
                    text: portalPaths.monitoring.title,
                    href: `${portalPaths.monitoring.path}/license-management`,
                    disabled: false,
                },
                {
                    text: portalPaths.monitoring.licenseManagement,
                    disabled: false,
                    href: portalPaths.monitoring.path,
                    isGoBack: true,
                },
                {
                    text: portalPaths.monitoring.viewEmployee,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.monitoring.path}/license-management/employee/edit/*`,
            title: portalPaths.monitoring.editEmployee,
            lists: [
                {
                    text: portalPaths.monitoring.title,
                    href: portalPaths.monitoring.path,
                    disabled: false,
                },
                {
                    text: portalPaths.monitoring.licenseManagement,
                    disabled: false,
                    href: portalPaths.monitoring.path,
                    isGoBack: true,
                },
                {
                    text: portalPaths.monitoring.editEmployee,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.monitoring.path}/license-management/employee/create`,
            title: portalPaths.monitoring.createEmployee,
            lists: [
                {
                    text: portalPaths.monitoring.licenseManagement,
                    href: portalPaths.monitoring.path,
                    disabled: false,
                },
                {
                    text: 'View license management',
                    disabled: false,
                    href: portalPaths.monitoring.path,
                    isGoBack: true,
                },
                {
                    text: portalPaths.monitoring.createEmployee,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.monitoring.path}/license-management/documents/*`,
            title: portalPaths.monitoring.viewOperatorDocument,
            lists: [
                {
                    text: portalPaths.monitoring.licenseManagement,
                    href: `${portalPaths.monitoring.path}/license-management`,
                    disabled: false,
                },
                {
                    text: portalPaths.monitoring.viewDocument,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.monitoring.path}/license-management/*`,
            title: 'View license management',
            lists: [
                {
                    text: portalPaths.monitoring.licenseManagement,
                    href: `${portalPaths.monitoring.path}/license-management`,
                    disabled: false,
                },
                {
                    text: 'View license management',
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.monitoring.path}/view/*`,
            title: portalPaths.monitoring.viewOperator,
            lists: [
                {
                    text: portalPaths.monitoring.title,
                    href: portalPaths.monitoring.path,
                    disabled: false,
                },
                {
                    text: portalPaths.monitoring.viewOperator,
                    disabled: true,
                },
            ],
        },
        {
            path: portalPaths.lcm.path,
            title: portalPaths.lcm.title,
            lists: [
                {
                    text: portalPaths.lcm.title,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.lcm.path}/create`,
            title: portalPaths.lcm.createEmployee,
            lists: [
                {
                    text: portalPaths.lcm.title,
                    href: portalPaths.lcm.path,
                    disabled: false,
                },
                {
                    text: portalPaths.lcm.createEmployee,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.lcm.path}/edit/*`,
            title: portalPaths.lcm.editEmployee,
            lists: [
                {
                    text: portalPaths.lcm.title,
                    href: portalPaths.lcm.path,
                    disabled: false,
                },
                {
                    text: portalPaths.lcm.editEmployee,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.lcm.path}/detail/*`,
            title: portalPaths.lcm.viewEmployee,
            lists: [
                {
                    text: portalPaths.lcm.title,
                    href: portalPaths.lcm.path,
                    disabled: false,
                },
                {
                    text: portalPaths.lcm.viewEmployee,
                    disabled: true,
                },
            ],
        },
        {
            path: portalPaths.management.path,
            title: portalPaths.management.title,
            lists: [
                {
                    text: portalPaths.management.title,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.management.path}/change-password/*`,
            title: portalPaths.management.changePassword,
            lists: [
                {
                    text: portalPaths.management.title,
                    href: portalPaths.management.path,
                    disabled: false,
                },
                {
                    text: portalPaths.management.changePassword,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.management.path}/system-security`,
            title: portalPaths.management.userSecurity,
            lists: [
                {
                    text: portalPaths.management.title,
                    href: portalPaths.management.path,
                    disabled: false,
                },
                {
                    text: portalPaths.management.userSecurity,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.management.path}/user-type/*`,
            title: portalPaths.management.userType,
            lists: [
                {
                    text: portalPaths.management.title,
                    href: portalPaths.management.path,
                    disabled: false,
                },
                {
                    text: portalPaths.management.userType,
                    href: `${portalPaths.management.path}/user-type`,
                    disabled: false,
                },
                {
                    text: portalPaths.management.userType,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.management.path}/user-type`,
            title: portalPaths.management.userType,
            lists: [
                {
                    text: portalPaths.management.title,
                    href: portalPaths.management.path,
                    disabled: false,
                },
                {
                    text: portalPaths.management.userType,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.management.path}/user-info`,
            title: portalPaths.management.userInfo,
            lists: [
                {
                    text: portalPaths.management.title,
                    href: portalPaths.management.path,
                    disabled: false,
                },
                {
                    text: portalPaths.management.userInfo,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.management.path}/user-info/edit/*`,
            title: portalPaths.management.editUserType,
            lists: [
                {
                    text: portalPaths.management.title,
                    href: portalPaths.management.path,
                    disabled: false,
                },
                {
                    text: portalPaths.management.userInfo,
                    href: `${portalPaths.management.path}/user-type`,
                    disabled: false,
                },
                {
                    text: portalPaths.management.editUserType,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.management.path}/user-info/create`,
            title: portalPaths.management.createUserType,
            lists: [
                {
                    text: portalPaths.management.title,
                    href: portalPaths.management.path,
                    disabled: false,
                },
                {
                    text: portalPaths.management.userInfo,
                    href: `${portalPaths.management.path}/user-type`,
                    disabled: false,
                },
                {
                    text: portalPaths.management.createUserType,
                    disabled: true,
                },
            ],
        },
        {
            path: `${portalPaths.management.path}/*`,
            title: portalPaths.management.userInfo,
            lists: [
                {
                    text: portalPaths.management.title,
                    href: portalPaths.management.path,
                    disabled: false,
                },
                {
                    text: portalPaths.management.userType,
                    href: portalPaths.management.path,
                    disabled: false,
                },
                {
                    text: portalPaths.management.userInfo,
                    disabled: true,
                },
            ],
        },
        {
            path: portalPaths.activity.path,
            title: portalPaths.activity.title,
            lists: [
                {
                    text: portalPaths.activity.title,
                    disabled: true,
                },
            ],
        },
        {
            path: portalPaths.applicationTracking.path,
            title: portalPaths.applicationTracking.title,
            lists: [
                {
                    text: portalPaths.applicationTracking.title,
                    disabled: true,
                },
            ],
        },
        {
            path: portalPaths.profileSettings.path,
            title: portalPaths.profileSettings.title,
            lists: [
                {
                    text: portalPaths.profileSettings.title,
                    disabled: true,
                },
            ],
        },
    ],
})

export const getters = {
    menubarInternalPortalWithPermissions: (state, getters, rootState) => {
        if (rootState.internal['role-permissions'].rolePermissions.length) {
            return state.menubarInternalPortal.map((el) => {
                return {
                    ...el,
                    display: rootState.internal[
                        'role-permissions'
                    ].rolePermissions.find(
                        (permission) => permission.permission_code === el.code
                    ).can_view,
                }
            })
        }
        return []
    },
}
